import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { MultiCategoryFetchData } from "../../redux/actions/categoryMultiAction";
import { getCategoriesFromCookie, setCategoriesToCookie } from "../../utils/userCookie";
import "./Foryou.css";
import HomeTaboola from "../subcomponents/HomeTaboola";

const Foryou = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const ForyouData = useSelector((state) => state.CategoryMultiReducer);
  const menuList = useSelector((state) => state?.MenuReducer);
  const menuTabsList = useSelector((state) => state?.MenuTabsReducer);
  const { 21: assetbaseUrl } = useSelector((state) => state?.SettingReducer?.data || {});
  
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [sparkles, setSparkles] = useState([]);

  const [allCategories, setAllCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [hasInitialFetched, setHasInitialFetched] = useState(false);

  // Base URL for images
  const imageBaseUrl = assetbaseUrl?.value || "https://epapercdn.sandesh.com/";

  useEffect(() => {
    let cats = [];
    if (menuList?.data) {
      Object.values(menuList.data).forEach(parent => {
        if (parent.name && parent.name !== "Supplement") cats.push({ name: parent.name, slug: parent.category });
      });
    }
    if (menuTabsList?.data) {
      Object.values(menuTabsList.data).forEach(sub => {
        if (sub.name && sub.name !== "Supplement") cats.push({ name: sub.name, slug: sub.category || sub.url });
      });
    }
    const uniqueCats = cats.filter((c, index, self) => index === self.findIndex((t) => (t.name === c.name)));
    setAllCategories(uniqueCats);
  }, [menuList, menuTabsList]);

  const loadSavedCategories = () => {
      const saved = getCategoriesFromCookie();
      if (saved && saved.length > 0) {
        setSelectedCategories(saved);
      } else {
        setSelectedCategories([]);
      }
  };

  useEffect(() => {
    loadSavedCategories();
  }, []);

  useEffect(() => {
    if (hasInitialFetched || allCategories.length === 0) return;

    const categories = getCategoriesFromCookie();
    if (categories) {  
      const formattedCategories = categories.map(catName => {
        if (typeof catName !== "string") return "";
        const catObj = allCategories.find(c => c.name === catName);
        if (catObj && catObj.slug) return catObj.slug;
        return catName.toLowerCase().replace(/\s+/g, '-');
      }).filter(Boolean);

      dispatch(
        MultiCategoryFetchData(
          "category",               
          {
            categories: formattedCategories,  
            page: 1,
            limit: 10,
          },          
          ""        
        )
      );
      setHasInitialFetched(true);
    }
  }, [dispatch, allCategories, hasInitialFetched]);

  const apiData = ForyouData?.data || {};
  const isLoading = ForyouData?.loading;

  const handleCategoryToggle = (catName) => {
    setSelectedCategories(prev => {
      const catObj = allCategories.find(c => c.name === catName);
      const nameLower = typeof catName === "string" ? catName.toLowerCase() : String(catName || "").toLowerCase();
      const slugLower = typeof catObj?.slug === "string" ? catObj.slug.toLowerCase() : String(catObj?.slug || "").toLowerCase();

      const isSelected = prev.some(c => {
        if (typeof c !== 'string') return false;
        const lowerC = c.toLowerCase();
        return lowerC === nameLower || lowerC === slugLower;
      });

      if (isSelected) {
        return prev.filter(c => {
          if (typeof c !== 'string') return false;
          const lowerC = c.toLowerCase();
          return lowerC !== nameLower && lowerC !== slugLower;
        });
      } else {
        return [catName, ...prev];
      }
    });
  };

  const handleSelectAll = () => {
    setSelectedCategories(allCategories.map(cat => cat.name));
  };

  const handleClearAll = () => {
    setSelectedCategories([]);
  };

  const handleSavePreferences = () => {
    setCategoriesToCookie(selectedCategories);
    
    setIsExpanded(false);
    setIsTransitioning(true);
    
    const formattedCategories = selectedCategories.map(catName => {
      if (typeof catName !== "string") return "";
      const catObj = allCategories.find(c => c.name === catName);
      if (catObj && catObj.slug) return catObj.slug;
      return catName.toLowerCase().replace(/\s+/g, '-');
    }).filter(Boolean);

    dispatch(
      MultiCategoryFetchData(
        "category",               
        {
          categories: formattedCategories,  
          page: 1,
          limit: 10,
        },          
        ""        
      )
    );

    setTimeout(() => {
      setIsTransitioning(false);
    }, 600);
  };

  const handleCancel = () => {
    setIsExpanded(false);
    loadSavedCategories();
  };

  // Staggered delay for bubbles
  const getBubbleStyle = (index) => ({
    transitionDelay: isExpanded ? `${Math.min(0.65, 0.1 + (index * 0.05))}s` : '0s'
  });

  const triggerSparkles = (e) => {
    const btnRect = e.currentTarget.getBoundingClientRect();
    const morphBox = document.getElementById("morph-box");
    if (!morphBox) return;
    
    const morphRect = morphBox.getBoundingClientRect();
    const startX = btnRect.left - morphRect.left + btnRect.width / 2;
    const startY = btnRect.top - morphRect.top + btnRect.height / 2;

    const newSparkles = Array.from({ length: 15 }).map((_, i) => {
      const angle = Math.random() * Math.PI * 2;
      const velocity = 30 + Math.random() * 50; 
      return {
        id: Date.now() + i,
        x: startX,
        y: startY,
        tx: Math.cos(angle) * velocity,
        ty: Math.sin(angle) * velocity,
        size: 3 + Math.random() * 5, 
      };
    });
    setSparkles(newSparkles);
    
    setTimeout(() => {
      setSparkles([]);
    }, 800);
  };


  const allPosts = Object.keys(apiData).flatMap((categoryKey) => {
    const category = apiData[categoryKey];
    if (!category?.status || !category?.data?.posts?.length) return [];
    const categoryTitle = typeof category?.name === 'string' ? category.name.split('|')[0].trim() : String(category?.name || categoryKey);
    return category.data.posts.map(post => ({
       ...post,
       fallbackCategoryName: categoryTitle,
       originalCategoryKey: categoryKey
    }));
  });

  const featuredRelatedPosts = allPosts.slice(1, 4);

  return (
    <div className="foryou-page-wrapper">       
      <div className="ambient-light light-1"></div>
      <div className="ambient-light light-2"></div>
      
      <div className="foryou-container">
        
        <div className="personalization-wrapper">
            <div className={`morph-container ${isExpanded ? 'expanded' : ''}`} id="morph-box">
                {sparkles.map((s) => (
                  <span
                    key={s.id}
                    className="magic-sparkle"
                    style={{
                      left: s.x,
                      top: s.y,
                      "--tx": `${s.tx}px`,
                      "--ty": `${s.ty}px`,
                      "--size": `${s.size}px`,
                    }}
                  />
                ))}
                <div className="banner-view">
                    <div className="foryou-header-content">
                        <div className="foryou-title-row">
                            <h1>તમારા માટે <span>(FOR YOU)</span></h1>
                            <div className="foryou-header-badge">
                                <i className="fa fa-star" aria-hidden="true"></i> વિશેષ
                            </div>
                        </div>
                        <p className="foryou-header-desc">તમારી પસંદગી મુજબના મેળવો તમામ તાજા સમાચાર માત્ર એક જ ક્લિક પર</p>
                    </div>
                    
                    <button className="foryou-header-icon" title="Curate Feed" onClick={(e) => { triggerSparkles(e); setIsExpanded(true); }} style={{ opacity: isTransitioning ? 0.6 : 1 }}>
                        <i className={`fa fa-magic ${isTransitioning ? 'fa-spin' : ''}`} aria-hidden="true"></i>
                    </button>
                </div>

                <div className="dashboard-view">
                    <div className="dashboard-header">
                        <div>
                            <h3>Customize Your Feed</h3>
                            <p style={{ color: '#666', marginTop: '5px', fontSize: '13px' }}>Pick the categories you love most ✨</p>
                        </div>
                        <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                            <button className="text-btn" id="bulk-all" onClick={handleSelectAll}
                                style={{ background: 'none', border: 'none', color: 'var(--accent-primary)', fontWeight: 700, cursor: 'pointer', fontSize: '13px' }}>Select
                                All</button>
                            <button className="text-btn" id="bulk-none" onClick={handleClearAll}
                                style={{ background: 'none', border: 'none', color: '#999', fontWeight: 700, cursor: 'pointer', fontSize: '13px' }}>Clear</button>
                        </div>
                    </div>

                    <div className="category-cloud" id="cloud-container">
                        {allCategories.map((cat, index) => {
                             const nameLower = typeof cat.name === "string" ? cat.name.toLowerCase() : String(cat.name || "").toLowerCase();
                             const slugLower = typeof cat.slug === "string" ? cat.slug.toLowerCase() : String(cat.slug || "").toLowerCase();
                             const isActive = selectedCategories.some(c => {
                               if (typeof c !== 'string') return false;
                               const lowerC = c.toLowerCase();
                               return lowerC === nameLower || lowerC === slugLower;
                             });
                             return (
                                <div 
                                    key={index} 
                                    className={`bubble ${isActive ? 'active' : ''}`} 
                                    onClick={() => handleCategoryToggle(cat.name)}
                                    style={getBubbleStyle(index)}
                                >
                                    {isActive && <i className="fa fa-check-circle" aria-hidden="true"></i>}
                                    {cat.name}
                                </div>
                             )
                        })}
                    </div>

                    <div className="dashboard-footer">
                        <button className="btn-main btn-close" id="collapse-btn" onClick={handleCancel}>Cancel</button>
                        <button className="btn-main btn-save" id="save-btn" onClick={handleSavePreferences}>Save Preferences ✨</button>
                    </div>
                </div>
            </div>
        </div>

        {isLoading ? (
          <div className="foryou-loading">
            <div className="spinner"></div>
          </div>
        ) : (
          <main>
            {allPosts.length === 0 ? (
              <div className="foryou-empty">
                <h3>હજુ સુધી કોઈ સમાચાર મળ્યા નથી</h3>
                <p>કૃપા કરીને તમારી પસંદગીઓ અપડેટ કરો.</p>
              </div>
            ) : (
              <div className="foryou-grid" id="news-grid">
                {allPosts.map((post, index) => {
                    if (index >= 1 && index <= 3) return null;
                    const imgUrl = `${imageBaseUrl}${post?.media ? post?.media?.replace("?resize=800,450", "") : ""}`;
                    const isFeatured = index === 0; 
                    const delay = (index % 12) * 0.1; 

                    return (
                      <Link 
                        to={`/${post?.url}`} 
                        className={`foryou-card ${isFeatured ? 'featured' : ''} ${isTransitioning ? 'animate-out' : 'animate-in'}`} 
                        style={{ 
                          animationDelay: isTransitioning ? `${(12 - index % 12) * 0.04}s` : `${delay}s` 
                        }}
                        key={`foryou-${post?.id}-${index}`}
                      >
                        <div className="card-image-wrap">
                          {post.media && (
                            <img 
                              className="card-image"
                              src={isFeatured ? `${imgUrl}?resize=800,450` : `${imgUrl}?resize=400,225`} 
                              alt={post?.media_title || post?.title} 
                              loading="lazy" 
                            />
                          )}
                          {post.video_yt && (
                            <div className="play-icon">
                              <i className="fa fa-play-circle" aria-hidden="true"></i>
                            </div>
                          )}
                        </div>
                        <div className="card-content">                          
                          {post?.publish_date && (
                            <div className="card-meta-top">
                              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="meta-icon">
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                <line x1="16" y1="2" x2="16" y2="6"></line>
                                <line x1="8" y1="2" x2="8" y2="6"></line>
                                <line x1="3" y1="10" x2="21" y2="10"></line>
                                <circle cx="12" cy="15" r="4"></circle>
                                <polyline points="12 13 12 15 13.5 16.5"></polyline>
                              </svg>
                              <span>{post?.publish_date}</span>
                            </div>
                          )}
                          <h2 className="card-title">{post.title}</h2>
                          {post.tagline && <p className="card-desc">{post.tagline}</p>}
                          
                          {isFeatured && featuredRelatedPosts?.length > 0 && (
                            <div className="featured-related-stories">
                              <h3 className="related-title">Top Stories</h3>
                              <div className="related-list">
                                {featuredRelatedPosts?.map((rp, rIndex) => (
                                  <div 
                                    className="related-item" 
                                    key={`related-${rp?.id}-${rIndex}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      navigate(`/${rp?.url}`);
                                    }}
                                  >
                                    <div className="related-bullet"></div>
                                    <div className="related-item-content">
                                      <h3 className="related-item-title">{rp?.title}</h3>
                                      <span className="related-item-date">{rp?.publish_date}</span>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                          <div className="card-read-more">
                            વધુ વાંચો 
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                          </div>
                        </div>
                      </Link>
                    );
                  })
                }
              </div>
            )}
          </main>
        )}
      </div>
       <HomeTaboola key={window.location.href} />
    </div>
  );
};

export default Foryou;
